export default "//yastatic.net/s3/distribution/pythia/frontend/_/d668c1a9b7a3f7bab66f038a0f5af658.jpeg";